import { useProductContext } from '../ProductContext';
import { ProductDetail } from './ProductDetail';
import { ProductSizeGuide } from './ProductDetailSizeGuide';
import { ProductDetailTrigger } from './ProductDetailTrigger';
import { Divider, Stack } from '@/src/packages/components';
import {
  useShippingReturnsDrawerStore,
  useSizeGuideDrawerStore,
  useWarrantyDrawerStore,
} from '@/src/packages/hooks/use-basket-drawer';
import { BadgeCheck, Package2, Ruler } from 'lucide-react';
import { ProductDetailCareGuides } from '@/src/packages/components/pages/Product/ProductDetails/ProductDetailCareGuides';

export const ProductDetails = () => {
  const {
    productVariant: {
      product: { sizeMatrix },
    },
  } = useProductContext();

  const { handleOpen } = useSizeGuideDrawerStore();

  const { handleOpen: handleOpenWarrantyDrawer } = useWarrantyDrawerStore();

  const { handleOpen: handleOpenShippingReturnsDrawer } =
    useShippingReturnsDrawerStore();

  return (
    <Stack divider={<Divider />}>
      {sizeMatrix && (
        <ProductDetail>
          <ProductDetailTrigger onClick={handleOpen} icon={Ruler}>
            Sizing information
          </ProductDetailTrigger>
          <ProductSizeGuide />
        </ProductDetail>
      )}
      <ProductDetail>
        <ProductDetailTrigger
          onClick={handleOpenShippingReturnsDrawer}
          icon={Package2}
        >
          Delivery &amp; returns
        </ProductDetailTrigger>
      </ProductDetail>
      <ProductDetail>
        <ProductDetailTrigger
          onClick={handleOpenWarrantyDrawer}
          icon={BadgeCheck}
        >
          Lifetime warranty
        </ProductDetailTrigger>
      </ProductDetail>
      <ProductDetailCareGuides />
    </Stack>
  );
};
